import { Navigate, Outlet } from 'react-router-dom';
import useCommerceScopedOperator from '@/pages/Business/hooks/useCommerceScopedOperator';

const BusinessScopeGuard = () => {
  const { isCommerceScopedOperator, isLoading } = useCommerceScopedOperator();

  if (isLoading) return null;

  if (isCommerceScopedOperator) {
    return <Navigate to='/business-commerces' replace />;
  }

  return <Outlet />;
};

export default BusinessScopeGuard;
